<template>
  <div>
    <v-row>
      <v-col>
        <h3 class="text-left mb-4 mt-10">Change user role</h3>
      </v-col>
    </v-row>
    <v-form>
      <v-row>
        <v-col>
          <p>Email</p>
          <v-text-field
            v-model="updatedUserProfile.email"
            variant="outlined"
            disabled
          />
        </v-col>
        <v-col>
          <p>Role</p>
          <v-autocomplete
            :items="roles"
            v-model="updatedUserProfile.role"
            variant="outlined"
          />
        </v-col>
      </v-row>
      <v-row justify="end">
        <PSecondaryButton class="mb-5 mr-3" @click="emit('cancel')"
          >Cancel</PSecondaryButton
        >
        <PPrimaryButton
          class="mb-5 mr-3"
          @click="putUserInfo"
          :disabled="props.userProfile.role === updatedUserProfile.role"
          >Update user</PPrimaryButton
        >
      </v-row>
    </v-form>
  </div>
</template>

<script setup lang="ts">
import { type Ref, ref } from "vue";
import { UserProfile } from "@/models/userProfile";
import { updateUserRole } from "@/services/userProfileAdminService";
import PPrimaryButton from "@/components/custom/buttons/PPrimaryButton.vue";
import PSecondaryButton from "@/components/custom/buttons/PSecondaryButton.vue";
import { genericError } from "@/modules/utilities";
import { useSnackBarStore } from "@/stores/snackBarStore";
import { UserProfileType } from "@/models/enum/userProfileType";

const props = defineProps({
  userProfile: {
    type: UserProfile,
    required: true,
  },
});

const emit = defineEmits<{
  (e: "cancel"): void;
  (e: "updated", userProfile: UserProfile): void;
}>();

const snackbarStore = useSnackBarStore();

const updatedUserProfile: Ref<UserProfile> = ref({ ...props.userProfile });
const roles = UserProfileType.AllowedUserProfileRoles;

async function putUserInfo() {
  try {
    await updateUserRole(updatedUserProfile.value);
    snackbarStore.showSuccess("Successfully updated user profile");
    emit("updated", updatedUserProfile.value);
  } catch (error) {
    snackbarStore.showError(genericError);
  }
}
</script>
